import CryptoJS from 'crypto-js';

// Clave de encriptación (en producción usar variable de entorno)
const ENCRYPTION_KEY = 'RutaBajioVerde2024$ecureK3y';

/**
 * Servicio de autenticación con almacenamiento seguro
 */
const authService = {
  /**
   * Encriptar datos
   */
  encrypt(data) {
    const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(jsonString, ENCRYPTION_KEY).toString();
  },

  /**
   * Desencriptar datos
   */
  decrypt(encryptedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    } catch {
      return null;
    }
  },

  /**
   * Verificar si hay sesión activa
   */
  isAuthenticated() {
    return localStorage.getItem('isAuthenticated') === 'true' && 
           sessionStorage.getItem('_at') !== null;
  },

  /**
   * Obtener access token desencriptado
   */
  getAccessToken() {
    const encrypted = sessionStorage.getItem('_at');
    if (!encrypted) return null;
    return this.decrypt(encrypted);
  },

  /**
   * Obtener refresh token desencriptado
   */
  getRefreshToken() {
    const encrypted = sessionStorage.getItem('_rt');
    if (!encrypted) return null;
    return this.decrypt(encrypted);
  },

  /**
   * Obtener datos del usuario
   */
  getUserData() {
    const encrypted = sessionStorage.getItem('_ud');
    if (!encrypted) return null;
    return this.decrypt(encrypted);
  },

  /**
   * Guardar datos del usuario
   */
  setUserData(userData) {
    const encrypted = this.encrypt(userData);
    sessionStorage.setItem('_ud', encrypted);
  },

  /**
   * Actualizar access token (para refresh)
   */
  setAccessToken(token) {
    const encrypted = this.encrypt(token);
    sessionStorage.setItem('_at', encrypted);
  },

  /**
   * Cerrar sesión - limpiar todos los datos
   */
  getUserGroup() {
    const userData = this.getUserData();
    const g = userData?.groups?.[0];
    if (!g) return null;
    const name = typeof g === 'object' ? (g.name ?? g.nombre ?? '') : g;
    const aliases = { Inversionistas: 'Inversionista', Tractoras: 'Tractora' };
    return aliases[name] ?? name;
  },
  logout() {
    sessionStorage.removeItem('_at');
    sessionStorage.removeItem('_rt');
    sessionStorage.removeItem('_ud');
    localStorage.removeItem('isAuthenticated');
  },

  /**
   * Guardar sesión completa
   */
  saveSession(accessToken, refreshToken) {
    sessionStorage.setItem('_at', this.encrypt(accessToken));
    sessionStorage.setItem('_rt', this.encrypt(refreshToken));
    localStorage.setItem('isAuthenticated', 'true');
  }
};

export default authService;
